import { render, staticRenderFns } from "./paiche.vue?vue&type=template&id=e988f20a&scoped=true"
import script from "./paiche.vue?vue&type=script&lang=js"
export * from "./paiche.vue?vue&type=script&lang=js"
import style0 from "./paiche.vue?vue&type=style&index=0&id=e988f20a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e988f20a",
  null
  
)

export default component.exports